import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import Constants from "../../AppConstants/Constants";
import Layout from "../../Layouts/LayoutMain";
import KitItemsContainer from "../../Components/Kits/KitItemsContainer";
import Wizard from "../../Components/Wizard/Wizard";
import KitPricingContainer from "../../Components/Kits/KitPricingContainer";
import KitAccessories from "../../Components/Kits/KitAccessories";
import { getXsrfToken } from "../../Store/Security/Actions";
import { addToCart, updateTempCart, updateTempCartKitUI } from "../../Store/Cart/Actions";
import { getDevices, getPlans, updateKitQuantity } from "../../Store/Catalog/Actions";
import { goNext, onFinish } from "../../Store/Wizard/Actions";
import { getProductDetails } from "../../Store/Product/Actions";

class KitBuild extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: null,
            fullDescription: null,
            price: null,
            picture: null,
            id: null,
            quantity: 1,
            currentlySelectedId: -1
        };

        this.addToCart = this.addToCart.bind(this);
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.onStepChanging = this.onStepChanging.bind(this);
        this.onSubmitFinished = this.onSubmitFinished.bind(this);
        this.closeDetails = this.closeDetails.bind(this);
        this.isEmpty = this.isEmpty.bind(this);
        this.currentSelection = this.currentSelection.bind(this);
    }

    componentWillMount() {
        const { getDevices, getPlans, devices, plans, config: { DEVICES_CATEGORY_ID, DATA_PLANS_CATEGORY_ID }, i18n, activeCurrency } = this.props;

        if (!devices || devices.length === 0 || devices[0].locale !== i18n.locale || devices[0].currencyCode !== activeCurrency.currencyCode) {
            getDevices(DEVICES_CATEGORY_ID, true, true, true);
        }

        if (!plans || plans.length === 0 || plans[0].locale !== i18n.locale || plans[0].currencyCode !== activeCurrency.currencyCode) {
            getPlans(DATA_PLANS_CATEGORY_ID, false, true);
        }
    }

    // componentWillReceiveProps(nextProps, nextContext) {
    //     const { i18n } = this.props;
    //     const { i18n: nextI18n, tempCart, devices, plans } = nextProps;
    //
    //     if (tempCart.Kit && !_.isEqual(i18n, nextI18n)) {
    //         const selectedKitId = Object.keys(tempCart.Kit)[0];
    //         const selectedPlanId = Object.keys(tempCart.Plan)[0];
    //         const selectedKit = _.find(devices, d => d.id == selectedKitId);
    //         const selectedPlan = _.find(plans, d => d.id == selectedPlanId);
    //         const accessoriesTempCart = _.cloneDeep(tempCart);
    //         delete accessoriesTempCart.Kit;
    //         delete accessoriesTempCart.Plan;
    //
    //         const newTempCart = {
    //             Kit: {},
    //             ...accessoriesTempCart
    //         };
    //
    //         newTempCart.Kit[selectedKit.id] = {
    //             ...selectedKit,
    //             quantity: tempCart.Kit[selectedKitId].quantity,
    //             attributeValueId: tempCart.Kit[selectedKitId].attributeValueId,
    //             productAttributeId: tempCart.Kit[selectedKitId].productAttributeId,
    //             productAttributeMapId: tempCart.Kit[selectedKitId].productAttributeMapId,
    //             productAttributePrice: tempCart.Kit[selectedKitId].productAttributePrice
    //         };
    //
    //         if (selectedPlan) {
    //             newTempCart.Plan = {};
    //
    //             newTempCart.Plan[selectedPlan.id] = {
    //                 ...selectedPlan,
    //                 quantity: tempCart.Plan[selectedPlanId].quantity,
    //                 attributeValueId: tempCart.Plan[selectedPlanId].attributeValueId,
    //                 productAttributeId: tempCart.Plan[selectedPlanId].productAttributeId,
    //                 productAttributeMapId: tempCart.Plan[selectedPlanId].productAttributeMapId,
    //                 productAttributePrice: tempCart.Plan[selectedPlanId].productAttributePrice
    //             };
    //         }
    //
    //         console.log("newTempCart", newTempCart);
    //     }
    // }

    addToCart() {
        const { wizards, goNext, onFinish, updateTempCartKitUI, updateKitQuantity, kitQuantity, config: { KITS_CATEGORY_ID, DATA_PLANS_CATEGORY_ID } } = this.props;
        const { data, id, optionClicked } = this.state;
        let { title, quantity } = this.state;

        if (quantity === 0) {
            alert(I18n.t("alerts.quantity"));
        } else {

            if (data.category.id === KITS_CATEGORY_ID) {
                title = "kit";
            } else if (data.category.id === DATA_PLANS_CATEGORY_ID) {
                title = "plan";
            }

            if (kitQuantity) {
                updateTempCart({ [title]: { [id]: { ...data, quantity: kitQuantity, ...optionClicked } } });
                updateTempCartKitUI({ [title]: { [id]: { ...data, quantity: kitQuantity, ...optionClicked } } });
            } else {
                updateKitQuantity(quantity);
                updateTempCart({ [title]: { [id]: { ...data, quantity: quantity } } });
                updateTempCartKitUI
            }

            const { totalSteps, currentStep } = wizards.Kits;

            if (currentStep > 0) {
                document.querySelector(".wizardDetailsQTY").style.backgroundColor = "#eee";
                document.querySelector(".wizardDetailsQTY").readOnly = true;
            }

            // Wizard is finished at the second to last step because the last step is the Cart
            if (currentStep === totalSteps) {
                onFinish("Kits");
            } else {
                goNext("Kits");
            }
            this.closeDetails();
            window.scrollTo(0, 0);
        }
    }

    currentSelection(id) {
        this.setState({currentlySelectedId: id});
    }

    onQuantityChange(quantity) {
        quantity = quantity === "" ? 0 : parseInt(quantity);
        updateKitQuantity(quantity);
        this.setState({ quantity })
    }

    onStepChanging(number) {
        if (number === 1) {
            const { updateKitQuantity, updateTempCart, updateTempCartKitUI } = this.props;
            updateKitQuantity(1);
            updateTempCartKitUI();
            updateTempCart();
        }
    }

    onSubmitFinished() {
        const { getXsrfToken, history, tempCart, addToCart, updateTempCart, updateTempCartKitUI, updateKitQuantity } = this.props;

        const items = [];
        let kitId = -1;
        _.each(tempCart, (category, categoryName) => {
            _.each(category, product => {
                const cartItem = {
                    ProductId: product.id,
                    Quantity: product.quantity
                };

                if (categoryName.toLowerCase() === "kit") {
                    kitId = product.id;
                } else {
                    cartItem.KitId = kitId;
                }

                if (product.productAttributeId) {
                    cartItem.AttributeControlIds = [`product_attribute_${product.id}_${product.productAttributeId}_${product.productAttributeMapId}_${product.attributeValueId}`];
                }

                items.push(cartItem);
            });
        });

        getXsrfToken(({ token }) => {
            addToCart({ items, __RequestVerificationToken: token }, true, () => {
                updateTempCart();
                updateTempCartKitUI();
                updateKitQuantity(1);
                history.push(Constants.ENDPOINTS.CART);
            });
        });
    }

    closeDetails() {
        $("#kitsContainer").show();
        $("#kitsDetailsContainer").hide();
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    render() {
        const { plans, devices, kitQuantity, tempCart } = this.props;
        const { currentlySelectedId } = this.state;

        // only show zebra and panasonic devices for build kit for now
        let buildKitDevices = [];
        _.each(devices, device => {
            if (device.sku === "FZ-N1EBJZZKM" || device.sku === "TC77HL-5ME24BG-NA") {
                buildKitDevices.push(device);
            }
        });

        // Getting selected kit from temp cart pass to accessories page for selected device, create 2 arrays for the types of attributes to be displayed on each page
        let selectedKit = {};
        let chargingAttributes = [];
        let optionalAttributes = [];

        if (tempCart.Kit) {
            const kitObj = tempCart.Kit;
            selectedKit = _.map(kitObj, obj => obj)[0];

            _.each(selectedKit.productAttributes, attribute => {
                const pageIndex = parseInt(attribute.displayOrder.toString()[0]);

                if (pageIndex === 1) {
                    chargingAttributes.push(attribute);
                }
                if (pageIndex === 2) {
                    optionalAttributes.push(attribute);
                }
            })
        }

        return (
            <Layout isAuthenticated={this.props.isAuthenticated}>
                <div id="kitsContainer" className="build-kit-container">
                    {this.isEmpty(tempCart) ?
                        <h2 className="build-kit-title"><Translate value="buildAKit.title" /></h2>
                        :
                        <KitPricingContainer kitQuantity={kitQuantity}/>
                    }
                    <Wizard
                        name="KitsBuild"
                        steps={[
                            { name: "buildAKit.wizard.steps.one.title", component: <KitItemsContainer key={0} items={buildKitDevices} filter="Kit" wizardName="KitsBuild" wizard={true} addToCart={true} showDetails={this.showDetails} setCurrentId={this.currentSelection} /> },
                            { name: "buildAKit.wizard.steps.two.title", component: <KitItemsContainer key={1} items={plans} filter="Plan" wizardName="KitsBuild" wizard={true} addToCart={true} qtyReadOnly={true} showDetails={this.showDetails} currentSelection={currentlySelectedId} /> },
                            { name: "buildAKit.wizard.steps.three.title", component: <KitAccessories key={2} attributes={chargingAttributes} filter="Charging Accessories" wizard={true} /> },
                            { name: "buildAKit.wizard.steps.four.title", component: <KitAccessories key={3} attributes={optionalAttributes} filter="Optional Accessories" wizard={true} /> }
                        ]}
                        onStepChanging={this.onStepChanging}
                        onFinished={this.onSubmitFinished}
                    />
                    {/* <WirelessPlanMessage /> */}
                </div>
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        activeCurrency: state.activeCurrency,
        requestCount: state.requestCount,
        cart: state.cart,
        tempCart: state.tempCart,
        tempCartKitUI: state.tempCartKitUI,
        wizards: state.wizards,
        kitQuantity: state.kitQuantity,
        devices: state.devices,
        plans: state.plans,
        selectedProduct: state.selectedProduct,
        config: state.config
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        getDevices: getDevices,
        getPlans: getPlans,
        addToCart: addToCart,
        updateTempCart: updateTempCart,
        updateTempCartKitUI: updateTempCartKitUI,
        updateKitQuantity: updateKitQuantity,
        goNext: goNext,
        onFinish: onFinish,
        getProductDetails: getProductDetails
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(KitBuild));